import React from 'react'

const LeftIcon = () => (
  <svg width="24" height="19" viewBox="0 0 24 19">
    <path
      d="M21 10H4l6-6-6 6 6 6"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default LeftIcon
